import React, { useState, useEffect } from 'react';

const COOKIE_CONSENT_KEY = 'cookieConsent-Meumulti-1.0.0';
const CookieConsentBanner = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(COOKIE_CONSENT_KEY);
    if (!consent) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, 'accepted');
    setIsVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, 'declined');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white/95 backdrop-blur-sm border-t border-[#e0e0e0] shadow-lg z-50 p-4 md:p-6">
      <div className="max-w-[1280px] mx-auto flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
        <div className="flex-1">
          <p className="text-sm md:text-base text-[#003424] leading-relaxed">
            Usamos cookies para melhorar sua experiência, personalizar conteúdo e analisar nosso tráfego. Ao continuar
            navegando, você aceita nossa{' '}
            <a
              href="https://www.meumulti.com.br/#/politica-de-privacidade"
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#014B35] font-semibold hover:underline underline"
            >
              Política de Privacidade
            </a>
            .
          </p>
        </div>
        <div className="flex gap-3 w-full md:w-auto">
          <button
            onClick={handleDecline}
            className="flex-1 md:flex-none bg-transparent border border-[#014B35] text-[#014B35] rounded-full px-6 py-3 text-sm font-semibold hover:bg-[#014B35] hover:text-white transition-colors duration-300"
          >
            Recusar
          </button>
          <button
            onClick={handleAccept}
            className="flex-1 md:flex-none bg-[#014B35] text-white rounded-full px-6 py-3 text-sm font-semibold hover:bg-[#003424] transition-colors duration-300"
          >
            Aceitar
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsentBanner;
